import styled from 'styled-components'

export const InfoContainer = styled.div`
  display: flex;
  margin-top: 24px;
  margin-bottom: -24px;
`
